import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { GenieShowcaseSelector } from "@/components/GenieShowcaseSelector";
import { Agent } from "@/types/agent/agent";

interface BrandTestFiltersProps {
  agents: Agent[];
  selectedAgent: string | null;
  onSelectedAgentChange: (agentId: string | null) => void;
  statusFilter: "all" | "passed" | "failed";
  onStatusFilterChange: (filter: "all" | "passed" | "failed") => void;
  dateRange: string;
  onDateRangeChange: (range: string) => void;
}

export const BrandTestFilters = ({
  agents,
  selectedAgent,
  onSelectedAgentChange,
  statusFilter,
  onStatusFilterChange,
  dateRange,
  onDateRangeChange,
}: BrandTestFiltersProps) => {
  return (
    <Card className="p-4 sm:p-6 mb-6">
      <div className="flex flex-col gap-5">
        {/* Agents - Showcase Selector */}
        <div>
          <div className="flex items-center justify-between mb-3">
            <h3 className="text-sm font-semibold text-gray-700">Genie</h3>
            <button
              onClick={() => onSelectedAgentChange(null)}
              className={`text-sm font-medium transition-colors ${
                selectedAgent === null
                  ? "text-genie-primary"
                  : "text-gray-500 hover:text-genie-primary"
              }`}
            >
              All Genies
              {selectedAgent === null && (
                <span className="ml-1.5 text-xs text-genie-primary">(selected)</span>
              )}
            </button>
          </div>
          <GenieShowcaseSelector
            agents={agents}
            selectedAgentId={selectedAgent}
            onSelectAgent={onSelectedAgentChange}
            showAllOption={false}
            containerId="brand-integrity-genie-selector"
          />
        </div>

        {/* Status and Date Range on same row */}
        <div className="flex flex-col sm:flex-row gap-4 sm:gap-8">
          {/* Status Filter */}
          <div>
            <h3 className="text-sm font-semibold text-gray-700 mb-2">Status</h3>
            <div className="flex flex-wrap gap-2">
              {(["all", "passed", "failed"] as const).map((status) => (
                <Button
                  key={status}
                  variant={statusFilter === status ? "default" : "outline"}
                  onClick={() => onStatusFilterChange(status)}
                  className="text-sm capitalize"
                >
                  {status === "all" ? "All Tests" : status === "failed" ? "Needs Review" : "Passed"}
                </Button>
              ))}
            </div>
          </div>

          {/* Date Range */}
          <div>
            <h3 className="text-sm font-semibold text-gray-700 mb-2">Date Range</h3>
            <div className="flex flex-wrap gap-2">
              {(["7d", "30d", "90d", "all"] as const).map((range) => (
                <Button
                  key={range}
                  variant={dateRange === range ? "default" : "outline"}
                  onClick={() => onDateRangeChange(range)}
                  className="text-sm"
                >
                  {range === "7d" ? "Last 7 days" : range === "30d" ? "Last 30 days" : range === "90d" ? "Last 90 days" : "All time"}
                </Button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};
